// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-of-use-header[data-v-d16d6306] {
  width: 100%;
  text-align: center;
  font-family: "Poppins", sans-serif;
  color: #495057;
}
.terms-of-use-header__title[data-v-d16d6306] {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: inherit;
}
.terms-of-use-header__subtitle[data-v-d16d6306] {
  margin: 4px 0 0;
  font-size: 14px;
  color: #757575;
}
.terms-of-use-body[data-v-d16d6306] {
  width: 100%;
  text-align: left;
}
.terms-of-use-footer[data-v-d16d6306] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-family: "Poppins", sans-serif;
}
@media (max-width: 575.98px) {
.terms-of-use-footer[data-v-d16d6306] {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
}
.terms-of-use-footer .terms-of-use-footer__button[data-v-d16d6306] {
    width: 100%;
}
}
.terms-of-use-footer__checkbox[data-v-d16d6306] {
  color: #374151;
}
.terms-of-use-footer__checkbox[data-v-d16d6306] .custom-control-label {
  font-family: inherit;
  font-weight: 500;
  font-size: 14px;
  color: inherit;
  padding-left: 8px;
}
.terms-of-use-footer__checkbox[data-v-d16d6306] .custom-control-label::before,
.terms-of-use-footer__checkbox[data-v-d16d6306] .custom-control-label::after {
  width: 18px;
  height: 18px;
  top: 1.5px;
}
.terms-of-use-footer__button[data-v-d16d6306] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: inherit;
  font-weight: 500;
  background-color: #53933a;
  border-color: #53933a;
  color: #fff;
}
.terms-of-use-footer__button[data-v-d16d6306]:hover:not(:disabled) {
  background-color: #467a30;
  border-color: #467a30;
  color: #fff;
}
.terms-of-use-footer__button[data-v-d16d6306]:disabled {
  background-color: #53933a;
  border-color: #53933a;
  opacity: 0.5;
  cursor: not-allowed;
}
.terms-of-use-footer__button[data-v-d16d6306]:hover:disabled {
  background-color: #53933a;
  border-color: #53933a;
  color: #fff;
  cursor: not-allowed;
}
.navbar[data-v-d16d6306] {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  font-family: Poppins;
}
.navbar .hamburger-container[data-v-d16d6306] {
  line-height: 25px;
  height: 100%;
  float: left;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;
}
.navbar .hamburger-container[data-v-d16d6306]:hover {
  background: rgba(0, 0, 0, 0.025);
}
.navbar .breadcrumb-container[data-v-d16d6306] {
  float: left;
}
.navbar .errLog-container[data-v-d16d6306] {
  display: inline-block;
  vertical-align: top;
}
.navbar .right-menu[data-v-d16d6306] {
  float: right;
  height: 100%;
  line-height: 30px;
}
.navbar .right-menu[data-v-d16d6306]:focus {
  outline: none;
}
.navbar .right-menu .right-menu-item[data-v-d16d6306] {
  display: inline-block;
  padding: 0 1px;
  height: 100%;
  font-size: 15px;
  color: #5a5e66;
  vertical-align: text-bottom;
}
.navbar .right-menu .right-menu-item.hover-effect[data-v-d16d6306] {
  cursor: pointer;
  transition: background 0.3s;
}
.navbar .right-menu .right-menu-item.hover-effect[data-v-d16d6306]:hover {
  background: rgba(0, 0, 0, 0.025);
}
.navbar .right-menu img.lang[data-v-d16d6306] {
  width: 40px;
  height: 25px;
  margin-bottom: 4px;
  cursor: pointer;
}
.navbar .right-menu .avatar-container[data-v-d16d6306] {
  margin-right: 30px;
}
.navbar .right-menu .avatar-container .avatar-wrapper[data-v-d16d6306] {
  margin-top: 0;
  position: relative;
}
.navbar .right-menu .avatar-container .avatar-wrapper .user-avatar[data-v-d16d6306] {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 10px;
}
.navbar .right-menu .avatar-container .avatar-wrapper .el-icon-caret-bottom[data-v-d16d6306] {
  cursor: pointer;
  position: absolute;
  right: -20px;
  top: 15px;
  font-size: 12px;
}
.navbar .right-menu .el-dropdown-menu__item .band[data-v-d16d6306] {
  width: 35px;
  height: 20px;
}
.empresa[data-v-d16d6306] {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 40%;
}
.select-company[data-v-d16d6306] {
  height: 30px;
}
.custom-select-company[data-v-d16d6306] {
  background-color: #53933a;
  color: #fff;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.custom-select-company .client-option[data-v-d16d6306] {
  background: #62af3a;
}
.custom-select-company .client-option[data-v-d16d6306]:link,
.custom-select-company .client-option[data-v-d16d6306]:visited,
.custom-select-company .client-option[data-v-d16d6306]:hover,
.custom-select-company .client-option[data-v-d16d6306]:active,
.custom-select-company .client-option[data-v-d16d6306]:focus {
  background: #53933a !important;
}
@media screen and (max-width: 470px) {
.empresa[data-v-d16d6306] {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.navbar[data-v-d16d6306] {
    height: 80px;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
